import React from 'react';

import { useRecoilValue } from 'recoil';

import { userDispensariesAtom } from 'src/app/state/user-dispensaries';

import { QueryBuilderMultiSelect } from './query-builder-multiselect';

type LocationDropdownProps = {
  disabled?: boolean;
  onChange: (value: (number | string)[]) => void;
  values: string;
};

type Location = {
  id: string;
  name: string;
};

export function LocationDropdown({ onChange, values, disabled = false }: LocationDropdownProps) {
  const { locations } = useRecoilValue(userDispensariesAtom);

  const transformedLocations: Location[] = (locations || []).map((location) => ({
    id: location.LocId,
    name: location.Name,
  }));

  return (
    <QueryBuilderMultiSelect<Location>
      automationIdPrefix='location'
      defaultLabel='Select a location'
      disabled={disabled}
      idKey='id'
      items={transformedLocations}
      nameKey='name'
      values={values}
      onChange={onChange}
    />
  );
}
